import { render, staticRenderFns } from "./SelectStudent.vue?vue&type=template&id=888e47f8&scoped=true&"
import script from "./SelectStudent.vue?vue&type=script&lang=js&"
export * from "./SelectStudent.vue?vue&type=script&lang=js&"
import style0 from "./SelectStudent.vue?vue&type=style&index=0&id=888e47f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888e47f8",
  null
  
)

export default component.exports